var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv4-2.jpg"
    }
  }, [_c('div', {
    staticClass: "text-ani-wrap mb-30 mb-lg-54"
  }, [_c('div', {
    staticClass: "text-ani mb-14 mb-lg-28"
  }, [_c('h2', {
    staticClass: "font-weight-bold font-size-40 font-size-md-54 font-size-lg-80 line-height-1"
  }, [_vm._v(" Brand Ambassador ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold line-height-1"
  }, [_vm._v(" 브랜드 홍보대사 ")])])]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" 최고의 브랜드 경험을 선사하는 "), _c('br'), _vm._v(" 브랜드 홍보 전문가 ")])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "video-wrap mb-30 mb-lg-54"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/ijEeV6zbIn4",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]), _c('p', {
    staticClass: "tit-txt text-center mb-8 mb-lg-24"
  }, [_vm._v(" 브랜드를 대표하는 얼굴이 되어 고객사의 브랜드를 알리고 홍보하는 브랜드 홍보대사. 서비스 구독자 모집, 국내외 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 상품 홍보 및 판매를 위한 캠페인을 진행하며 다양한 산업 분야의 고객사를 경험할 수 있습니다. ")]), _c('p', {
    staticClass: "tit-txt text-center mb-8 mb-lg-24"
  }, [_vm._v(" 브랜드 홍보대사는 정확한 정보를 전달하고 긍정적인 브랜드 경험을 선사합니다. 지속적인 교육을 통해 고객사의 제품, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 서비스를 완벽하게 이해하고, 브랜드 가치를 전달하는 영업 전문가로 성장할 수 있습니다. ")])])], 1), _c('section', {
    staticClass: "section bg-grey section-top-image",
    staticStyle: {
      "background-image": "url(/images/sub/recruitment/ambassador/s2-bg.jpg)"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-left"
  }, [_c('h3', {
    staticClass: "tit color-white font-weight-bold"
  }, [_vm._v(" 왜 "), _c('br'), _vm._v(" 세일즈웍스와 "), _c('br'), _vm._v(" 함께할까요? ")])]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/ambassador/s2-img1.jpg",
      "tit": "전문적인 세일즈 대행",
      "titWidth": "w-xl-40"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 세일즈웍스의 브랜드 홍보대사는 전문적인 세일즈 스킬을 갖춘 영업 전문가입니다. 얼굴을 마주하고 소통하는 대면 영업으로 고객사의 상품과 서비스를 홍보, 판매하고 잠재 고객에게 긍정적인 이미지로 브랜드를 홍보합니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/ambassador/s2-img2.jpg",
      "tit": "사람 중심의 소통하는 문화",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 즐겁게 일하는 인재는 세일즈웍스의 경쟁력입니다. 서로 존중하며 즐겁게 일하고 자유롭게 소통할 수 있는 수평적 조직문화를 위해 다양한 시도를 하고 있습니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/ambassador/s2-img3.jpg",
      "tit": "체계적인 교육과 해외연수",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 세일즈웍스는 함께하는 모두가 최고의 전문가로 성장하기를 바랍니다. 체계적인 교육과 다양한 국내외 워크샵 및 해외 연수의 기회를 제공하여 원하는 만큼 도전하고, 성장할 수 있도록 지원합니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/ambassador/s2-img4.jpg",
      "tit": "국제적인 네트워크와 풍부한 경험",
      "titWidth": "w-xl-62"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 세일즈웍스는 아시아 전역의 다양한 비즈니스 파트너들과 혁신적인 아이디어를 공유하며 교류하고 있습니다. 1995년 설립 이래 쌓아온 국제적인 노하우를 바탕으로 제품 판매, 후원자 유치, 서비스 구독자 확보 등 다양한 산업군에 맞춤형 캠페인을 제공합니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/ambassador/s2-img5.jpg",
      "tit": "상한선 없는 정당한 보상",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 프리랜서로서 자기 주도적으로 일하는 브랜드 홍보대사는 성과에 따라 노력에 대한 정당한 보상을 받습니다. 또한 다양한 인센티브를 통해 성취감을 갖고 일할 수 있습니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/ambassador/s2-img6.jpg",
      "tit": "사업적 성장의 기회",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 브랜드 홍보대사는 세일즈 활동 외에도 분야를 넓혀 역량을 발휘할 수 있습니다. 글로벌 네트워크를 바탕으로 한 체계적인 교육과 컨설팅 등 다방면의 지원을 통해 경쟁력을 갖춘 전문 경영인으로 성장할 수 있습니다. ")])])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 홍보채널 ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v(" 전국 지점을 바탕으로 다양한 채널에서 캠페인 활동이 가능합니다. ")])]), _c('v-row', {
    staticClass: "text-center",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-img', {
    staticClass: "w-100 mb-16 mb-lg-30",
    attrs: {
      "src": "/images/sub/recruitment/ambassador/s3-img1.jpg"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-point mb-2 mb-lg-0",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 대중 캠페인 ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 인구밀집지역 ")]), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 상업지구, 번화가와 같이 유동인구가 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 많은 지역에서 일반 대중을 대상으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 캠페인을 진행하여 고객 유치 ")])], 1), _c('v-col', {
    staticClass: "mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-img', {
    staticClass: "w-100 mb-16 mb-lg-30",
    attrs: {
      "src": "/images/sub/recruitment/ambassador/s3-img2.jpg"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-point mb-2 mb-lg-0",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 이벤트 행사 ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 축제, 행사, 쇼핑몰, 백화점 등 ")]), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 전국 영업망과 누적 데이터를 바탕으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 최적의 이벤트 장소를 선별하여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 캠페인 진행 ")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-img', {
    staticClass: "w-100 mb-16 mb-lg-30",
    attrs: {
      "src": "/images/sub/recruitment/ambassador/s3-img3.jpg"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-point mb-2 mb-lg-0",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" B2B / B2C ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 일반 기업 및 사무실 밀집 지역 ")]), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 상업시설, 오피스 등을 방문하여 기업 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 또는 개인에게 맞춤형 홍보 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 판매 대행 서비스 진행 ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }